<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <b-card>
      <template slot="header">
        <h3 class="inline float-left">Cadastrar cupom</h3>
        <b-button class="float-right" variant="success" @click="cadastrar"
          >Confirmar Cadastro</b-button
        >
        <b-button class="float-right mr-3" variant="danger" @click="goBack"
          >Cancelar Cadastro</b-button
        >
      </template>
      <b-row>
        <b-col cols="12">
          <b-card no-body class="no-margin-bottom">
            <div class="text-center">
              <h4>Selecione um filtro para realizar o envio dos cupons</h4>
              <small
                >Selecionado:
                {{
                  tabIndex == 0
                    ? "Todos os clientes"
                    : tabIndex == 1
                    ? "Por interesse"
                    : "Por seleção"
                }}</small
              >
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <table>
            <tr>
              <td class="ml-3 mt-3">
                <c-switch
                  class="mx-1"
                  v-model="expira"
                  color="success"
                  checked
                  variant="3d"
                />
              </td>
              <td>
                <span>
                  &nbsp;
                  <strong>Expira</strong>
                </span>
              </td>
            </tr>
          </table>
        </b-col>

        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Titulo">
            <b-form-input
              id="titulo"
              v-model="titulo"
              @keyup.enter="focus('descricao')"
            />
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Descrição">
            <b-form-input
              id="descricao"
              v-model="descricao"
              @keyup.enter="focus('dataIni')"
            />
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Data Inicial" class="date-input">
            <datepicker
              id="dataIni"
              class="form-control"
              v-model="datainicial"
              :language="ptBR"
              :format="customFormatter"
              :disabledDates="disabledDatesStart"
              :key="disabledDatesStart != null"
              @selected="mudaDataInicial"
              v-if="datainicial != null"
            ></datepicker>
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Data Final" class="date-input">
            <datepicker
              id="dataFim"
              v-bind:class="{ naoexpira: !expira }"
              class="form-control"
              v-model="datafinal"
              :language="ptBR"
              :format="customFormatter"
              :disabledDates="disabledDatesEnd"
              :key="disabledDatesEnd != null"
              :disabled="!expira"
              @selected="focus('horaIni')"
              v-if="datafinal != null"
            ></datepicker>
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Hora Inicial" class="time-input">
            <timeselector
              id="horaIni"
              v-model="horaInicial"
              class="form-control"
              :displayFormat="'HH:mm'"
            ></timeselector>
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Hora Final" class="time-input">
            <timeselector
              id="horaFim"
              v-model="horaFinal"
              class="form-control"
              :displayFormat="'HH:mm'"
              v-bind:class="{ naoexpira: !expira }"
              :disabled="expiraHour"
            ></timeselector>
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Tipo Desconto">
            <b-form-select
              v-model="descontoSelecionado"
              :options="options"
              @change="focus('valor')"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12" class="mt-3">
          <b-input-group prepend="Valor">
            <the-mask
              id="valor"
              mask="##"
              v-model="valorDesconto"
              type="text"
              class="form-control"
              placeholder="Digite o valor do desconto"
              v-if="descontoSelecionado == 1 || descontoSelecionado == 2"
            />
            <input disabled class="form-control" v-else />
          </b-input-group>
        </b-col>
        <b-col cols="12" class="mt-3">
          <b-tabs v-model="tabIndex">
            <b-tab title="Todos os clientes" active>
              <p class="texto-all-clientes">
                Enviará para todos os clientes cadastrados na plataforma mobile,
                que totaliza
                <strong>{{ qtdClientesCadastrados }}</strong>
                {{ qtdClientesCadastrados == 1 ? "cliente" : "clientes" }}.
              </p>
            </b-tab>
            <b-tab title="Por interesse">
              <p>Enviará de acordo com os interesses selecionados.</p>
              <b-row>
                <b-col xl="6" lg="6" md="12" sm="12">
                  <b-form-group>
                    <b-input-group size="sm" prepend="Buscar">
                      <b-form-input
                        v-model="filterInteresses"
                        type="search"
                        id="filterInput"
                        placeholder="Digite para pesquisar"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          :disabled="!filterInteresses"
                          @click="filterInteresses = ''"
                          >Limpar</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col xl="6" lg="6" md="12" sm="12">
                  <b-pagination
                    v-model="currentPageInteresses"
                    :total-rows="paginacaoInteresses"
                    :per-page="perPageInteresses"
                    align="fill"
                    size="sm"
                  ></b-pagination>
                </b-col>
              </b-row>
              <b-card header="Interesses">
                <b-col>
                  <b-table
                    :items="interesses"
                    :fields="interessesFields"
                    striped
                    hover
                    responsive="sm"
                    bordered
                    :filter="filterInteresses"
                    :filterIncludedFields="filterOnInteresses"
                    @filtered="onFilteredInteresses"
                    :current-page="currentPageInteresses"
                    :per-page="perPageInteresses"
                  >
                    <template #cell(selecionado)="data">
                      <b-button
                        size="md"
                        @click="selecionaInteresse(data.item)"
                        class="mr-2"
                        variant="danger"
                        v-if="verificaInteresseEscolhido(data.item.id)"
                      >
                        -
                      </b-button>
                      <b-button
                        size="md"
                        @click="selecionaInteresse(data.item)"
                        class="mr-2"
                        variant="success"
                        v-else
                      >
                        +
                      </b-button>
                    </template>
                  </b-table>
                  <b-row>
                    <b-col>
                      <b-button
                        class="btn-classic-float-right"
                        variant="success"
                        @click="selecionaTodosInteresses"
                        >Selecionar Todos</b-button
                      >
                      <b-button
                        class="btn-classic-float-right"
                        variant="danger"
                        @click="removerTodosInteresse"
                        >Desmarcar Todos</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-card>
              <b-card header="Interesses selecionados">
                <b-col>
                  <b-table
                    ref="selectableTable"
                    :items="interessesEscolhidos"
                    :fields="interessesFieldsSelected"
                    striped
                    hovers
                    responsive="sm"
                    bordered
                  >
                    <template #cell(selecionado)="data">
                      <b-button
                        size="md"
                        @click="selecionaInteresse(data.item)"
                        class="mr-2"
                        variant="danger"
                        v-if="verificaInteresseEscolhido(data.item.id)"
                      >
                        -
                      </b-button>
                      <b-button
                        size="md"
                        @click="selecionaInteresse(data.item)"
                        class="mr-2"
                        variant="danger"
                        v-else
                      >
                        -
                      </b-button>
                    </template>
                  </b-table>
                </b-col>
              </b-card>
            </b-tab>
            <b-tab title="Por seleção">
              <p>Selecione o(s) clientes(s) para o envio</p>
              <b-row>
                <b-col xl="6" lg="6" md="12" sm="12">
                  <b-form-group>
                    <b-input-group size="sm" prepend="Buscar">
                      <b-form-input
                        v-model="filterClientes"
                        type="search"
                        id="filterInputSelecao"
                        placeholder="Digite para pesquisar"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          :disabled="
                            filterInteresses != null && filterInteresses != ''
                          "
                          @click="filterClientes = ''"
                          >Limpar</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col xl="6" lg="6" md="12" sm="12">
                  <b-pagination
                    v-model="currentPageClientes"
                    :total-rows="paginacaoClientes"
                    :per-page="perPageClientes"
                    align="fill"
                    size="sm"
                  ></b-pagination>
                </b-col>
              </b-row>
              <b-card header="Clientes">
                <b-col>
                  <b-table
                    :items="clientes"
                    :fields="clientesFields"
                    striped
                    hovers
                    responsive="sm"
                    bordered
                    :filter="filterClientes"
                    :filterIncludedFields="filterOnClientes"
                    @filtered="onFilteredClientes"
                    :current-page="currentPageClientes"
                    :per-page="perPageClientes"
                    show-empty
                  >
                    <template v-slot:empty="">
                      <h4>Não achamos nenhum registro.</h4>
                    </template>

                    <template v-slot:emptyfiltered="">
                      <center>
                        <h5>Não achamos nenhum registro em sua busca.</h5>
                      </center>
                    </template>

                    <template #cell(selecionado)="data">
                      <b-button
                        size="md"
                        @click="selecionaCliente(data.item)"
                        class="mr-2"
                        variant="danger"
                        v-if="verificaClienteEscolhido(data.item.id)"
                      >
                        -
                      </b-button>
                      <b-button
                        size="md"
                        @click="selecionaCliente(data.item)"
                        class="mr-2"
                        variant="success"
                        v-else
                      >
                        +
                      </b-button>
                    </template>
                  </b-table>
                </b-col>
              </b-card>
              <b-card header="Clientes Selecionados">
                <b-col>
                  <b-table
                    ref="selectableTable"
                    :items="clientesEscolhidos"
                    :fields="clientesFieldsSelected"
                    striped
                    stickycollumn
                    hovers
                    responsive="sm"
                    bordered
                  >
                    <template #cell(selecionado)="data">
                      <b-button
                        size="md"
                        @click="selecionaCliente(data.item)"
                        class="mr-2"
                        variant="danger"
                        v-if="verificaClienteEscolhido(data.item.id)"
                      >
                        -
                      </b-button>
                      <b-button
                        size="md"
                        @click="selecionaCliente(data.item)"
                        class="mr-2"
                        variant="success"
                        v-else
                      >
                        +
                      </b-button>
                    </template>
                  </b-table>
                </b-col>
              </b-card>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import Timeselector from "vue-timeselector";
import Loading from "vue-loading-overlay";

import * as config from "@/config.json";
import axios from "axios";
import moment from "moment";
import "moment-timezone";
import { TheMask } from "vue-the-mask";
import { Money } from "v-money";

export default {
  name: "cadastrar-cupom",
  components: {
    cSwitch,
    TheMask,
    Loading,
    moment,
    Datepicker,
    Timeselector,
    Money,
  },
  data: function () {
    return {
      isLoading: false,
      titulo: null,
      descricao: null,
      valorDesconto: null,
      expira: false,
      expiraHour: false,
      descontoSelecionado: null,
      options: [
        { value: null, text: "Selecione o tipo do desconto" },
        { value: 1, text: "Porcentagem" },
        { value: 2, text: "Valor" },
      ],
      datainicial: null,
      datafinal: null,
      ptBR: ptBR,
      disabledDatesStart: null,
      disabledDatesEnd: null,
      tabIndex: 0,
      qtdClientesCadastrados: 0,
      interesses: [],
      interessesEscolhidos: [],
      interessesFields: [
        { key: "id", label: "Id" },
        { key: "descricao", label: "Descrição" },
        { key: "quantidade", label: "Clientes atingidos" },
        { key: "selecionado", label: "Selecionar" },
      ],
      interessesFieldsSelected: [
        { key: "id", label: "Id" },
        { key: "descricao", label: "Descrição" },
        { key: "selecionado", label: "Desmarcar Seleção" },
      ],
      selecionarTodosOsInteresses: false,
      clientes: [],
      clientesFields: [
        "id",
        "nome",
        "sobrenome",
        { key: "email", label: "E-Mail" },
        { key: "numero", label: "Telefone" },
        { key: "selecionado", label: "Selecionar" },
      ],
      clientesFieldsSelected: [
        "id",
        "nome",
        "sobrenome",
        { key: "email", label: "E-Mail" },
        { key: "numero", label: "Telefone" },
        { key: "selecionado", label: "Desmarcar Seleção" },
      ],
      clientesEscolhidos: [],
      selecionarTodosOsClientes: false,
      filterInteresses: null,
      filterOnInteresses: [],
      currentPageInteresses: 1,
      perPageInteresses: 5,
      totalRowsInteresses: 1,
      filterClientes: null,
      currentPageClientes: 1,
      perPageClientes: 5,
      filterOnClientes: [],
      totalRowsClientes: 1,
      horaInicial: new Date(),
      horaFinal: new Date(),
      hora: null,
      horaAtual: null,
      minutoAtual: null,
      horaValida: null,
      dados: [],
      price: 0,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 0,
        masked: false,
      },
    };
  },
  methods: {
    async retornaParametros() {
      const url = `${
        config.default.servidor
      }/gerencial/retorna-parametros-configurar-distribuicao/${localStorage
        .getItem("enterprise_id")
        .toString()}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });
        if (response.status == 200) {
          this.qtdClientesCadastrados = response.data.todosOsClientes;
          this.interesses = response.data.interesses;
          this.clientes = response.data.clientes;
        }
      } catch (error) {
        await this.$alert(`Erro: ${error}`, "Aviso", "error");
        console.log({ error });
      }
    },

    onFilteredInteresses() {
      this.currentPageInteresses = 1;
    },
    onFilteredClientes() {
      this.currentPageClientes = 1;
    },

    async selecionaTodosInteresses() {
      this.removerTodosInteresse();

      await this.interesses.map((interesse) => {
        this.interessesEscolhidos.push({
          id: interesse.id,
          descricao: interesse.descricao,
        });
      });
    },

    selecionaInteresse(record) {
      const interesse = this.interessesEscolhidos.find(
        (interesse) => interesse.id == record.id
      );

      if (!interesse) {
        this.interessesEscolhidos.push({
          id: record.id,
          descricao: record.descricao,
        });
      } else {
        this.removerInteressePorId(record.id);
      }
    },

    verificaInteresseEscolhido(id) {
      const filteredInterests = this.interessesEscolhidos.filter(
        (interest) => interest.id == id
      );
      return filteredInterests.length > 0;
    },

    removerTodosInteresse() {
      this.interessesEscolhidos.splice(0, this.interessesEscolhidos.length);
    },

    removerInteressePorId(id) {
      const arr = this;
      arr.interessesEscolhidos.forEach(function (el, index) {
        if (el.id === id) {
          arr.interessesEscolhidos.splice(index, 1);
        }
      });
    },

    removerPorId(id) {
      const arr = this;
      arr.clientesEscolhidos.forEach(function (el, index) {
        if (el.id === id) {
          arr.clientesEscolhidos.splice(index, 1);
        }
      });
    },

    verificaClienteEscolhido(id) {
      const filteredClients = this.clientesEscolhidos.filter(
        (clients) => clients.id == id
      );
      return filteredClients.length > 0;
    },

    selecionaCliente(record) {
      const cliente = this.clientesEscolhidos.find(
        (cliente) => cliente.id == record.id
      );

      if (!cliente) {
        this.clientesEscolhidos.push({
          id: record.id,
          nome: record.nome,
          sobrenome: record.sobrenome,
          email: record.email,
          numero: record.numero
        });
      } else {
        this.removerPorId(record.id);
      }
    },

    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    async mudaDataInicial(data) {
      if (data) {
        this.datainicial = new Date(data);
        if (moment(this.datainicial).isSameOrAfter(this.datafinal)) {
          this.datafinal = new Date(moment(this.datainicial).add(1, "days"));
          this.disabledDatesEnd.to = new Date(this.datainicial);
        }
        this.focus("dataFim");
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    verificaCampos() {
      if (!this.titulo) {
        return {
          isValid: false,
          message: "Necessário preencher o título",
        };
      }

      if (!this.descricao) {
        return {
          isValid: false,
          message: "Necessário preencher a descrição",
        };
      }

      if (!this.descontoSelecionado) {
        return {
          isValid: false,
          message: "Valor de desconto não selecionado",
        };
      }

      if (!this.valorDesconto) {
        return {
          isValid: false,
          message: "Valor de desconto inválido",
        };
      }

      if (!this.isValidDate(this.datainicial)) {
        return {
          isValid: false,
          message: "Data inicial inválida",
        };
      }

      if (this.expira) {
        if (!this.isDueDateValid(this.datafinal)) {
          return {
            isValid: false,
            message: "Data final inválida",
          };
        }
      }

      if (this.tabIndex == 1) {
        if (!this.isValidSelectArray(this.interessesEscolhidos)) {
          return {
            isValid: false,
            message: "Necessário selecionar ao menos um interesse",
          };
        }
      }

      if (this.tabIndex == 2) {
        if (!this.isValidSelectArray(this.clientesEscolhidos)) {
          return {
            isValid: false,
            message: "Necessário selecionar ao menos um cliente",
          };
        }
      }

      return {
        isValid: true,
        message: "",
      };
    },

    isValidSelectArray(array) {
      if (array.length > 0) {
        return true;
      }

      return false;
    },

    isDueDateValid(date) {
      if (!this.isValidDate(date)) {
        return false;
      }

      if (moment(this.datainicial).isAfter(this.datafinal)) {
        return false;
      }

      return true;
    },

    isValidDate(date) {
      if (date) {
        return true;
      }
      return false;
    },

    prepararDados() {
      if (this.tabIndex == 1 && this.interessesEscolhidos.length > 0) {
        return this.interessesEscolhidos;
      }

      if (this.tabIndex == 2 && this.clientesEscolhidos.length > 0) {
        return this.clientesEscolhidos;
      }

      return [];
    },

    buildParams(
      empresaid,
      tipo,
      dados,
      titulo,
      descricao,
      tipoid,
      valorDesconto,
      datainicial,
      datafinal,
      horainicial,
      horafinal
    ) {
      return {
        empresaid: empresaid,
        obj: {
          tipo: tipo,
          dados: dados,
          titulo: titulo,
          descricao: descricao,
          tipoid: tipoid,
          valorDesconto: valorDesconto,
          datainicial: datainicial,
          datafinal: datafinal,
          horainicial: horainicial,
          horafinal: horafinal,
        },
      };
    },

    async atualizaCupom() {
      const url = `${config.default.servidor}/gerencial/cupom/`;
      const data = this.buildParams(
        localStorage.getItem("enterprise_id"),
        this.tabIndex,
        (this.dados = this.prepararDados()),
        this.titulo,
        this.descricao,
        this.descontoSelecionado,
        this.valorDesconto,
        moment(this.datainicial).format("YYYY-MM-DD"),
        this.expira ? moment(this.datafinal).format("YYYY-MM-DD") : null,
        moment.tz(this.horaInicial, "America/Sao_Paulo").format("HH:mm"),
        moment.tz(this.horaFinal, "America/Sao_Paulo").format("HH:mm")
      );

      try {
        const response = await axios({
          url,
          method: "post",
          data,
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.isLoading = false;
          await this.$alert("Cupom criado!", "Sucesso", "success");
          this.$router.push({ path: `/cupons` });
        }
      } catch (error) {
        console.log({ error });
        if (error.response.status == 403) {
          this.isLoading = false;
          await this.$alert("Não foi possível criar o cupom!", "Erro", "error");
        } else {
          if (error.response.status == 412) {
            this.isLoading = false;
            await this.$alert(
              error.response.data.errorMessage,
              "Erro",
              "error"
            );
          }
        }
      }
    },

    async cadastrar() {
      this.isLoading = true;
      const result = this.verificaCampos();
      if (result.isValid) {
        if (this.valorDesconto > 15) {
          this.isLoading = false;

          const res = await this.$swal({
            title: "Cadastro de cupom",
            text: `Valor de desconto superior a 15${
              this.descontoSelecionado == 1 ? "%" : " reais"
            }. Deseja Continuar?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
          });

          if (res.value) {
            await this.atualizaCupom();
          }
        } else {
          await this.atualizaCupom();
        }
      } else {
        this.isLoading = false;
        await this.$alert(result.message, "Aviso", "warning");
      }
    },

    focus(id) {
      document.getElementById(id).focus();
    },
  },
  async beforeMount() {
    this.isLoading = true;

    this.datainicial = moment().format("YYYY-MM-DD hh:mm");
    this.datafinal = moment().add(1, "days").format("YYYY-MM-DD hh:mm");

    this.disabledDatesStart = {};
    this.disabledDatesStart.to = new Date(moment().subtract(1, "days"));

    this.disabledDatesEnd = {};
    this.disabledDatesEnd.to = new Date(this.datainicial);

    await this.retornaParametros();

    this.isLoading = false;
  },

  computed: {
    paginacaoInteresses() {
      return this.interesses.length;
    },

    paginacaoClientes() {
      return this.clientes.length;
    },
  },
};
</script>



